import {computed, inject, Injectable} from '@angular/core';
import {injectQuery} from '@tanstack/angular-query-experimental';
import {lastValueFrom} from 'rxjs';
import {LegalEntityService} from '../../../../api';
import {LegalEntitySummary} from '../../../../api/models';
import {QueryKey} from '../../../constants/query-key';

@Injectable({providedIn: 'root'})
export class LegalEntityStore {
  private readonly legalEntityService = inject(LegalEntityService);

  private readonly legalEntitiesQuery = injectQuery(() => ({
    queryKey: [QueryKey.LEGAL_ENTITIES],
    queryFn: () => lastValueFrom(this.legalEntityService.getLegalEntities()),
  }));

  legalEntities = computed<LegalEntitySummary[]>(() => this.legalEntitiesQuery.data()?.legalEntities ?? []);
  isDataLoading = computed(() => this.legalEntitiesQuery.isLoading());
}
